<template>
  <div ref="editorDOM">
    <div class="windowInfoWrap m-main" ref="innerDOM">
      <div class="title">体检套餐</div>
      <div class="Tab">
          <span class="one-span" :class="{ active: tabNum == 1 }" @click="clickTab(1)"> 
            普通
          </span>
          <span class="two-span" :class="{ active: tabNum == 2 }" @click="clickTab(2)">
            VIP
          </span>
      </div>
      <div class="mobileTable" v-if="SCREEN.mobile">
        <div
          class="tableData"
          v-for="(item, index) in medicalExamData"
          :key="index"
        >
          <div class="item" @click="savePhysicalEaxmInfo(item)">
            <div class="left">套餐名称：</div>
            <div class="right">{{ item.packageName }}</div>
          </div>
          <div class="item">
            <div class="left">所属性别：</div>
            <div class="right">
              <span v-if="item.packageSex == 5">通用</span>
              <span v-if="item.packageSex == 1">男</span>
              <span v-if="item.packageSex == 4">女未婚</span>
              <span v-if="item.packageSex == 3">女已婚</span>
            </div>
          </div>
          <div class="item">
            <div class="left">套餐价格：</div>
            <div class="right">￥{{ item.packagePrice }}（单价：元）</div>
          </div>
        </div>
      </div>
      <div class="tablebox" v-else>
        <a-table
          :columns="columns"
          :data-source="medicalExamData"
          :pagination="false"
        >
          <span slot="packagePrice" slot-scope="text, record">
            ￥{{ text }}（单价：元）
          </span>
          <span slot="action" slot-scope="text, record">
            <a
              slot="action"
              href="javascript:;"
              @click="savePhysicalEaxmInfo(record)"
              >{{ text }}</a
            >
          </span>
          <span slot="packageSex" slot-scope="text, record">
            <span v-if="record.packageSex == 5">通用</span>
            <span v-if="record.packageSex == 1">男</span>
            <span v-if="record.packageSex == 2">女</span>
            <span v-if="record.packageSex == 4">女未婚</span>
            <span v-if="record.packageSex == 3">女已婚</span>
          </span>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "hospital-physicalExaminationPackageList-hf",
  data() {
    return Object.assign(
      {
        columns: [
          {
            title: "套餐名称",
            dataIndex: "packageName",
            key: "packageName",
            width:400,
            scopedSlots: {
              customRender: "action"
            }
          },
          {
            title: "所属性别",
            dataIndex: "packageSex",
            key: "packageSex",
            scopedSlots: {
              customRender: "packageSex"
            }
          },
          {
            title: "套餐价格",
            dataIndex: "packagePrice",
            key: "packagePrice",
            scopedSlots: {
              customRender: "packagePrice"
            }
          }
        ],
        tabNum:1,
        ExamDataLabel:[],
        medicalExamData: [
        ]
      }
    );
  },

  mounted() {
    this.getMedicalExamLabel();
  },

  methods: {
    clickTab(num){
      this.tabNum = num;
      if(this.tabNum ==1){
        // 调用普通套餐接口
        this.getMedicalExamLabel();
      }else{
        // 调用VIP套餐接口(接口暂无先不写)
        this.medicalExamData = [];
      }
    },
    savePhysicalEaxmInfo(item) {
      this.$router.push({
          path: '/medicalCenter/medicalPackageDetails',
          query: { packageSex:item.packageSex,packageCode: item.packageCode,packageLevel:item.packageLevel},
        })
    },
    getMedicalExamLabel() {
      this.$API
        .getMedicalExamLabel({
          hospitalCode: "H02",
          packageRange: "5",
          // labelName:'优享套餐',
          // labelId:10
        })
        .then(res => {
          // this.$set(this, "medicalExamData", res.data);
          this.$set(this, "ExamDataLabel", res.data);
            for(let i=0; i<this.ExamDataLabel.length;i++){
              let par ={
                hospitalCode: "H02",
                packageRange: "5",
                labelName: this.ExamDataLabel[i].labelName,
                labelId:this.ExamDataLabel[i].labelId
              }
              this.$API.getMedicalExamList(par).then((res) => {
                if(res.code==0){
                  this.medicalExamData = this.medicalExamData.concat(res.data);
                }
              })
            }
        });
    }
  }
};
</script>

<style lang="less" scoped>
.title{
  font-size: 24px;
  display: flex;
  justify-content: center;
  padding-top: 30px;
  margin-bottom: 30px;
}
.Tab{
  background-color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
  .one-span {
        display: inline-block;
        width: 112px;
        height: 54px;
        line-height: 54px;
        box-shadow: 0px 1px 12px 0px #ccc;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
        &.active {
          background: #0079d4;
          border-color: #0079d4;
          color: #fff;
        }
      }
  .two-span {
        display: inline-block;
        width: 112px;
        height: 54px;
        line-height: 54px;
        box-shadow: 0px 1px 12px 0px #ccc;
        margin-left:10px;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
        &.active {
          background: #0079d4;
          border-color: #0079d4;
          color: #fff;
        }
      }
}
.mobileTable {
  padding-top: 0.4rem;
  .tableData {
    margin-bottom: 0.2rem;
    .item {
      border-top: 1px solid #ddd;
      display: flex;
      justify-content: center;
      font-size: 0.28rem;
      padding: 0.2rem 0;
      .left {
        width: 30%;
        text-align: right;
      }
      .right {
        width: 70%;

        padding-left: 0.1rem;
      }
    }
    .item:last-child {
      border-bottom: 1px solid #ddd;
    }
  }
  .more {
    padding: 0.4rem 0;
    display: flex;
    justify-content: center;
    .btn {
      font-size: 0.28rem;
      display: inline-block;
      vertical-align: top;
      border: 1px solid;
      border-radius: 1rem;
      padding: 0.1rem 0.3rem;
    }
  }
}
.windowInfoWrap {
  padding-bottom:30px;
  .tablebox {
    margin-top: 42px;
    /deep/.ant-table-thead > tr:first-child > th {
      background: #0078d4;
      font-size: 16px;
      height: 56px;
      text-align: center;
      color: #fff;
      font-weight: 100;
      border-left: 2px solid #fff;
    }
    /deep/.ant-table-tbody > tr > td {
      text-align: center;
      color: #474747;
      a {
        color: #474747;
      }
    }
  }
}

.m-screen-mobile {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  margin-bottom: 1rem;
}
</style>
